import type { ReactNode } from 'react'

interface BadgeProps {
  children: ReactNode
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info' | 'premium' | 'secondary'
  size?: 'sm' | 'md' | 'lg'
  className?: string
  title?: string
}

const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  title
}: BadgeProps) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full'
  
  // WCAG AA compliant color combinations using 3-color system
  const variantClasses = {
    default: 'bg-neutral-100 text-neutral-800 border border-neutral-200',
    success: 'bg-success-50 text-success-800 border border-success-200',
    warning: 'bg-warning-50 text-warning-800 border border-warning-200', 
    danger: 'bg-danger-50 text-danger-800 border border-danger-200',
    info: 'bg-primary-50 text-primary-800 border border-primary-200',
    premium: 'bg-gradient-to-r from-primary-50 to-secondary-50 text-neutral-800 border border-primary-200',
    secondary: 'bg-secondary-50 text-secondary-800 border border-secondary-200'
  }
  
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  }

  return (
    <span
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      title={title}
    >
      {children}
    </span>
  )
}

export default Badge
export { Badge }